import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { moment, Big } = Util;
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import TagStatus from "components/Pages/Finance/_cmpt/TagStatus";
import Countdown from "components/Pages/Finance/_cmpt/Countdown";
import TagAddr from "components/Pages/Finance/_cmpt/TagAddr";
import useCountdown from "components/Pages/Finance/_hook/useCountdown";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import Currency from "@/components/Pages/Finance/_cmpt/Currency";
import Card from "./Card";
import { Carousel } from "antd";
import svgArrow from "./arrow.svg";

export default observer(({ data }) => {
  const t = useTranslation();
  const { app, finance, fund } = useStore();

  const [product, setProduct] = useState(data.productCollections[0].financialProducts[0]);
  useEffect(() => {
    setProduct(data.productCollections[0].financialProducts[0]);
  }, [data]);

  const [financialProducts, setFinancialProducts] = useState(data.productCollections[0].financialProducts);
  useEffect(() => {
    setFinancialProducts(data.productCollections[0].financialProducts);
  }, [data]);

  const price = useMemo(() => {
    const { interestCurrency } = product;
    const precision = fund.getCurrencyPrecision("usdt");
    // console.log(fund.getCoinValue(1, "usdt"), interestCurrency);
    return Big(fund.getCoinValue(10000000, (interestCurrency || "").toLowerCase()) || 0)
      .div(+fund.getCoinValue(10000000, "usdt") || 1)
      .toFixed(precision);
  }, [fund.assistPriceMap, product]);
  const countdown = useMemo(() => {
    const { financeProductStatus, subscribeStartTime, subscribeEndTime, workStartTime, workEndTime } = product;
    if (financeProductStatus === "WARMING") {
      return {
        label: t("finance.preSubscribingStartsIn"),
        destTimestamp: subscribeStartTime,
      };
    }
    if (financeProductStatus === "PRE_SUBSCRIBING") {
      return {
        label: t("finance.miningStartsIn"),
        destTimestamp: workStartTime,
      };
    }
    if (financeProductStatus === "MINING" || financeProductStatus === "ONGOING") {
      return {
        label: t("finance.miningEndsIn"),
        destTimestamp: workEndTime,
      };
    }
    if (financeProductStatus === "CLOSED") {
      return {
        label: t("finance.miningEndsIn"),
        destTimestamp: workEndTime,
      };
    }
  }, [product]);
  const stakingProgress = useMemo(() => {
    const { duration, workStartTime } = product;
    let dist = moment().diff(moment(workStartTime), "days");
    dist < 0 && (dist = 0);
    dist > duration && (dist = duration);
    return dist + "/" + duration;
  }, [product]);

  const slidesToShow = useMemo(() => {
    if (app.windowInnerWidth <= 768) return 1;
    else if (app.windowInnerWidth <= 1024) return 2;
    else return 3;
  }, [app.windowInnerWidth]);

  const [timeStamp, setTimeStamp] = useState("");
  const stepFunc = useCallback(() => {
    console.log("stepFunc=====", Date.now());
    setTimeStamp(Date.now());
  }, []);

  return (
    <div className={styles.main}>
      <div className={styles.leftCon}>
        <TagStatus type={"staking"} data={product.financeProductStatus} className={styles.tag} />
        <div className={styles.leftConHead}>
          <Currency data={product.interestCurrency} isOnlyLogo />
          <div>
            <div>
              <span>{product.interestCurrency.toUpperCase()}</span>
              {app.isH5 && <TagAddr data={product} />}
            </div>
            <div>
              <div>{t("finance.price") + ": "}</div>
              <div>{price + " USDT"}</div>
            </div>
          </div>
        </div>
        {!app.isH5 && (
          <div className={styles.leftConTags}>
            <TagAddr data={product} />
          </div>
        )}
        <div className={styles.leftConDetail}>
          <div>
            <div>{t("finance.totalRewards")}</div>
            <div>{product.totalReward + " " + product.interestCurrency.toUpperCase()}</div>
          </div>
          <div>
            <div>{t("finance.farmingPeriod")}</div>
            <div>{product.duration + " " + t("finance.days")}</div>
          </div>
          <div>
            <div>{t("finance.stakingProgress")}</div>
            <div>{stakingProgress}</div>
          </div>
          {app.isH5 && (
            <div>
              <div>{countdown.label}</div>
              <Countdown data={countdown.destTimestamp} className={styles.leftConCountdownMain} stepFunc={stepFunc} />
            </div>
          )}
        </div>
        {!app.isH5 && (
          <div className={styles.leftConCountdown}>
            <div>{countdown.label}</div>
            <Countdown data={countdown.destTimestamp} className={styles.leftConCountdownMain} stepFunc={stepFunc} />
          </div>
        )}
      </div>
      <div className={styles.splitLine}></div>
      <div className={styles.rightCon}>
        <Carousel
          arrows={!app.isH5}
          slidesToShow={slidesToShow}
          infinite={false}
          dots={app.isH5}
          prevArrow={<img src={svgArrow} />}
          nextArrow={<img src={svgArrow} />}
        >
          {financialProducts.map((data) => (
            <div key={data.id}>
              <Card key={data.id + "-" + timeStamp} data={data} financialProducts={financialProducts} setFinancialProducts={setFinancialProducts} />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
});
